/**
 * @generated SignedSource<<838bcd5d18aadfc1eee4db68a8a6e8b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookingType = "DINING" | "LESSON" | "STANDARD";
export type SlotType = "BUCKET" | "MULTI" | "QUEUE" | "SINGLE";
export type LessonBookingWizardQueryRendererQuery$variables = {
  bookingType: BookingType;
  clubSlug: string;
  currentDate: string;
  facilityId: string;
  instructorId: string;
  lessonTypeId: string;
  membershipTypeId: string;
  players?: ReadonlyArray<string | null | undefined> | null | undefined;
  slotId: string;
  slotType?: SlotType | null | undefined;
};
export type LessonBookingWizardQueryRendererQuery$data = {
  readonly club: {
    readonly " $fragmentSpreads": FragmentRefs<"BookingWizardUIHeaderFragment">;
  } | null | undefined;
  readonly currentServerTime: string;
  readonly lessonRates: {
    readonly " $fragmentSpreads": FragmentRefs<"useInitializeLessonBookingWizardLessonType">;
  } | null | undefined;
  readonly node: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"AddPlayersStepNode" | "BookingWizardUIFooterFragment" | "LessonWizardStepContainerNode" | "useInitializeLessonBookingWizardNode">;
  } | null | undefined;
  readonly session: {
    readonly currentClientProfile: {
      readonly " $fragmentSpreads": FragmentRefs<"AddPlayersPrivateStepClientProfile" | "AddPlayersStepClientProfile" | "PreviousBookingsStepClientProfile">;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"useInitializeLessonBookingWizardSession">;
  } | null | undefined;
};
export type LessonBookingWizardQueryRendererQuery = {
  response: LessonBookingWizardQueryRendererQuery$data;
  variables: LessonBookingWizardQueryRendererQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bookingType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "clubSlug"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currentDate"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "facilityId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "instructorId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lessonTypeId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "membershipTypeId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "players"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slotId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slotType"
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentServerTime",
  "storageKey": null
},
v11 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "clubSlug"
  }
],
v12 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "slotId"
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v14 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "lessonTypeId"
  }
],
v15 = {
  "kind": "Variable",
  "name": "players",
  "variableName": "players"
},
v16 = [
  {
    "alias": "publicId",
    "args": null,
    "kind": "ScalarField",
    "name": "renderingKey",
    "storageKey": null
  }
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v19 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isNode"
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v21 = {
  "alias": "standardCapacity",
  "args": [
    {
      "kind": "Literal",
      "name": "bookingType",
      "value": "STANDARD"
    }
  ],
  "kind": "ScalarField",
  "name": "capacity",
  "storageKey": "capacity(bookingType:\"STANDARD\")"
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "usedCapacity",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "Facility",
  "kind": "LinkedField",
  "name": "facility",
  "plural": false,
  "selections": [
    (v20/*: any*/),
    (v13/*: any*/)
  ],
  "storageKey": null
},
v24 = {
  "kind": "Literal",
  "name": "bookingType",
  "value": "LESSON"
},
v25 = {
  "kind": "Variable",
  "name": "lessonTypeId",
  "variableName": "lessonTypeId"
},
v26 = {
  "fields": [
    (v24/*: any*/),
    {
      "kind": "Variable",
      "name": "facilityId",
      "variableName": "facilityId"
    },
    (v25/*: any*/)
  ],
  "kind": "ObjectValue",
  "name": "slotAvailability"
},
v27 = {
  "alias": null,
  "args": [
    (v24/*: any*/),
    (v25/*: any*/)
  ],
  "kind": "ScalarField",
  "name": "capacity",
  "storageKey": null
},
v28 = [
  (v13/*: any*/)
],
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "Course",
  "kind": "LinkedField",
  "name": "course",
  "plural": false,
  "selections": (v28/*: any*/),
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supportsPrivate",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patronSelectVenue",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patronAccess",
  "storageKey": null
},
v34 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "singular",
    "storageKey": null
  }
],
v35 = [
  (v26/*: any*/)
],
v36 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "enabled",
      "value": true
    },
    {
      "kind": "Variable",
      "name": "validOnDate",
      "variableName": "currentDate"
    }
  ],
  "concreteType": "SquareCardOnFileConnection",
  "kind": "LinkedField",
  "name": "squareCards",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SquareCardOnFileEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SquareCardOnFile",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v13/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "enabled",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "default",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "expMonth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "expYear",
              "storageKey": null
            },
            (v18/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cardBrand",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastFour",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "profileImage",
  "plural": false,
  "selections": (v16/*: any*/),
  "storageKey": null
},
v41 = [
  (v13/*: any*/),
  (v37/*: any*/),
  (v38/*: any*/),
  (v39/*: any*/),
  (v40/*: any*/)
],
v42 = {
  "kind": "InlineFragment",
  "selections": (v28/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "membershipType",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    (v13/*: any*/)
  ],
  "storageKey": null
},
v44 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": [
      "REQUEST"
    ]
  }
],
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "liftAt",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requestCloses",
  "storageKey": null
},
v47 = [
  (v13/*: any*/),
  (v18/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RequestConfig",
        "kind": "LinkedField",
        "name": "requestConfig",
        "plural": false,
        "selections": (v28/*: any*/),
        "storageKey": null
      }
    ],
    "type": "RequestRule",
    "abstractKey": null
  }
],
v48 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "clientCanFulfillRequests",
    "storageKey": null
  },
  (v13/*: any*/)
],
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "time",
  "storageKey": null
},
v50 = [
  (v49/*: any*/)
],
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "Request",
  "kind": "LinkedField",
  "name": "request",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "bookingRule",
      "plural": false,
      "selections": (v47/*: any*/),
      "storageKey": null
    },
    (v13/*: any*/),
    (v49/*: any*/)
  ],
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seriesIndex",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seriesCount",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "durationMins",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "dateLte",
      "variableName": "currentDate"
    },
    {
      "kind": "Variable",
      "name": "slotType",
      "variableName": "slotType"
    }
  ],
  "concreteType": null,
  "kind": "LinkedField",
  "name": "repeatableBookings",
  "plural": true,
  "selections": [
    (v18/*: any*/),
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "RoundConnection",
      "kind": "LinkedField",
      "name": "rounds",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RoundEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v18/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "player",
                  "plural": false,
                  "selections": [
                    (v18/*: any*/),
                    (v13/*: any*/),
                    (v38/*: any*/),
                    (v39/*: any*/),
                    (v40/*: any*/)
                  ],
                  "storageKey": null
                },
                (v13/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isBooking"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requestScheduleBlockingScope",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        (v18/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            {
              "alias": "configuredRequestRestrictions",
              "args": (v44/*: any*/),
              "concreteType": "AgendaBookingRulesConnection",
              "kind": "LinkedField",
              "name": "requestWindowBookingRules",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AgendaBookingRulesEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    (v45/*: any*/),
                    (v46/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": (v47/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "requestWindowBookingRules(type:[\"REQUEST\"])"
            },
            (v13/*: any*/),
            (v30/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Club",
                  "kind": "LinkedField",
                  "name": "club",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "supportsPublic",
                      "storageKey": null
                    },
                    (v13/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PrivateBookingPermissionSet",
                  "kind": "LinkedField",
                  "name": "privateBookingPermissionSet",
                  "plural": false,
                  "selections": (v48/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PublicBookingPermissionSet",
                  "kind": "LinkedField",
                  "name": "publicBookingPermissionSet",
                  "plural": false,
                  "selections": (v48/*: any*/),
                  "storageKey": null
                },
                (v20/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lessonsDisplayName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FacilityCopyOverrides",
                  "kind": "LinkedField",
                  "name": "copyOverrides",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NounOverride",
                      "kind": "LinkedField",
                      "name": "lesson",
                      "plural": false,
                      "selections": (v34/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Department",
                  "kind": "LinkedField",
                  "name": "department",
                  "plural": false,
                  "selections": [
                    (v20/*: any*/),
                    (v17/*: any*/),
                    (v13/*: any*/)
                  ],
                  "storageKey": null
                },
                (v17/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CourseConnection",
                  "kind": "LinkedField",
                  "name": "courses",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "count",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                (v13/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v13/*: any*/),
        {
          "kind": "TypeDiscriminator",
          "abstractKey": "__isSlot"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "configuredRequestRestrictions",
              "args": (v44/*: any*/),
              "concreteType": "SlotBookingRulesConnection",
              "kind": "LinkedField",
              "name": "requestWindowBookingRules",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SlotBookingRulesEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    (v45/*: any*/),
                    (v46/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "requestWindowBookingRules(type:[\"REQUEST\"])"
            },
            (v49/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "groupLabel",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "holeOffset",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BookingConnection",
              "kind": "LinkedField",
              "name": "bookings",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BookingEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v18/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RoundConnection",
                          "kind": "LinkedField",
                          "name": "rounds",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "RoundEdge",
                              "kind": "LinkedField",
                              "name": "edges",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": null,
                                  "kind": "LinkedField",
                                  "name": "node",
                                  "plural": false,
                                  "selections": [
                                    (v18/*: any*/),
                                    (v13/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": null,
                                      "kind": "LinkedField",
                                      "name": "player",
                                      "plural": false,
                                      "selections": [
                                        (v18/*: any*/),
                                        (v38/*: any*/),
                                        (v39/*: any*/),
                                        (v40/*: any*/),
                                        (v13/*: any*/)
                                      ],
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        (v13/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Course",
              "kind": "LinkedField",
              "name": "course",
              "plural": false,
              "selections": [
                (v17/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CourseBucket",
                  "kind": "LinkedField",
                  "name": "courseBucket",
                  "plural": false,
                  "selections": [
                    (v17/*: any*/),
                    (v13/*: any*/)
                  ],
                  "storageKey": null
                },
                (v13/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "TimeSlot",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v50/*: any*/),
          "type": "BucketTimeSlot",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v51/*: any*/),
        (v52/*: any*/),
        (v53/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeSlot",
          "kind": "LinkedField",
          "name": "fullfillableSlots",
          "plural": true,
          "selections": (v28/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SlotConnection",
          "kind": "LinkedField",
          "name": "slots",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SlotEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v18/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": (v50/*: any*/),
                      "type": "TimeSlot",
                      "abstractKey": null
                    },
                    (v13/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "startSlot",
          "plural": false,
          "selections": [
            (v20/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Agenda",
              "kind": "LinkedField",
              "name": "agenda",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Facility",
                  "kind": "LinkedField",
                  "name": "facility",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Club",
                      "kind": "LinkedField",
                      "name": "club",
                      "plural": false,
                      "selections": [
                        (v31/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v22/*: any*/),
                (v21/*: any*/)
              ],
              "type": "TimeSlot",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RoundConnection",
          "kind": "LinkedField",
          "name": "rounds",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoundEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "player",
                      "plural": false,
                      "selections": [
                        (v37/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CourseLayout",
                      "kind": "LinkedField",
                      "name": "courseLayout",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "code",
                          "storageKey": null
                        },
                        (v17/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "holeCount",
                          "storageKey": null
                        },
                        (v13/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "nonPlayingHost",
                          "storageKey": null
                        }
                      ],
                      "type": "MemberRound",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v54/*: any*/)
      ],
      "type": "StandardBooking",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v51/*: any*/),
        (v52/*: any*/),
        (v53/*: any*/),
        (v54/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "StaffProfileConnection",
          "kind": "LinkedField",
          "name": "instructors",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "StaffProfileEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StaffProfile",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v13/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "StaffUser",
                      "kind": "LinkedField",
                      "name": "user",
                      "plural": false,
                      "selections": [
                        (v37/*: any*/),
                        (v13/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "LessonBooking",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "roomName",
          "storageKey": null
        }
      ],
      "type": "DiningBooking",
      "abstractKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "LessonBookingWizardQueryRendererQuery",
    "selections": [
      (v10/*: any*/),
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BookingWizardUIHeaderFragment"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v12/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AddPlayersStepNode"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useInitializeLessonBookingWizardNode"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LessonWizardStepContainerNode"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BookingWizardUIFooterFragment"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "lessonRates",
        "args": (v14/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useInitializeLessonBookingWizardLessonType"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useInitializeLessonBookingWizardSession"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              {
                "args": [
                  (v15/*: any*/)
                ],
                "kind": "FragmentSpread",
                "name": "AddPlayersStepClientProfile"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AddPlayersPrivateStepClientProfile"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PreviousBookingsStepClientProfile"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v8/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v2/*: any*/),
      (v9/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "LessonBookingWizardQueryRendererQuery",
    "selections": [
      (v10/*: any*/),
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "logoImage",
            "plural": false,
            "selections": (v16/*: any*/),
            "storageKey": null
          },
          (v17/*: any*/),
          (v13/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v12/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v18/*: any*/),
          (v13/*: any*/),
          (v19/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requirePlayerCounts",
                "storageKey": null
              },
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "bookingType",
                    "variableName": "bookingType"
                  }
                ],
                "kind": "ScalarField",
                "name": "capacity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Agenda",
                "kind": "LinkedField",
                "name": "agenda",
                "plural": false,
                "selections": [
                  (v23/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedUntil",
                "storageKey": null
              }
            ],
            "type": "TimeSlot",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "firstStartSlot",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  },
                  (v26/*: any*/)
                ],
                "concreteType": "TimeSlotConnection",
                "kind": "LinkedField",
                "name": "startSlots",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimeSlotEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeSlot",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v27/*: any*/),
                          (v22/*: any*/),
                          (v29/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Agenda",
                            "kind": "LinkedField",
                            "name": "agenda",
                            "plural": false,
                            "selections": [
                              (v30/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "QueueSlot",
                                "kind": "LinkedField",
                                "name": "queueSlot",
                                "plural": false,
                                "selections": (v28/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Facility",
                                "kind": "LinkedField",
                                "name": "facility",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Club",
                                    "kind": "LinkedField",
                                    "name": "club",
                                    "plural": false,
                                    "selections": [
                                      (v31/*: any*/),
                                      (v13/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PrivateLessonsPermissionSet",
                                    "kind": "LinkedField",
                                    "name": "privateLessonsPermissionSet",
                                    "plural": false,
                                    "selections": [
                                      (v32/*: any*/),
                                      (v33/*: any*/),
                                      (v13/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PublicLessonsPermissionSet",
                                    "kind": "LinkedField",
                                    "name": "publicLessonsPermissionSet",
                                    "plural": false,
                                    "selections": [
                                      (v32/*: any*/),
                                      (v33/*: any*/),
                                      (v13/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "requirePaymentCardOnFile",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "prePaymentRequirement",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v13/*: any*/),
                                  (v17/*: any*/),
                                  {
                                    "alias": null,
                                    "args": [
                                      (v24/*: any*/)
                                    ],
                                    "concreteType": "GroupSize",
                                    "kind": "LinkedField",
                                    "name": "minMaxGroupSize",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "min",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "max",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "minMaxGroupSize(bookingType:\"LESSON\")"
                                  },
                                  (v20/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FacilityCopyOverrides",
                                    "kind": "LinkedField",
                                    "name": "copyOverrides",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "NounOverride",
                                        "kind": "LinkedField",
                                        "name": "course",
                                        "plural": false,
                                        "selections": (v34/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CourseConnection",
                                    "kind": "LinkedField",
                                    "name": "courses",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CourseEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Course",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "CourseBucket",
                                                "kind": "LinkedField",
                                                "name": "courseBucket",
                                                "plural": false,
                                                "selections": (v28/*: any*/),
                                                "storageKey": null
                                              },
                                              (v13/*: any*/),
                                              (v17/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "description",
                                                "storageKey": null
                                              },
                                              (v23/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v13/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "allStartSlodIds",
                "args": (v35/*: any*/),
                "concreteType": "TimeSlotConnection",
                "kind": "LinkedField",
                "name": "startSlots",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimeSlotEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeSlot",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v28/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v35/*: any*/),
                "concreteType": "TimeSlotConnection",
                "kind": "LinkedField",
                "name": "startSlots",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimeSlotEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeSlot",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v27/*: any*/),
                          (v22/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "allLessonStartSlotIds",
                "args": (v35/*: any*/),
                "concreteType": "TimeSlotConnection",
                "kind": "LinkedField",
                "name": "startSlots",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimeSlotEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeSlot",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v29/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "AvailabilitySlot",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "lessonRates",
        "args": (v14/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v18/*: any*/),
          (v19/*: any*/),
          (v13/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultDurationMins",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "instructorId",
                    "variableName": "instructorId"
                  }
                ],
                "kind": "ScalarField",
                "name": "durations",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "items": [
                      {
                        "kind": "Variable",
                        "name": "instructorIds.0",
                        "variableName": "instructorId"
                      }
                    ],
                    "kind": "ListValue",
                    "name": "instructorIds"
                  },
                  {
                    "kind": "Variable",
                    "name": "membershipTypeId",
                    "variableName": "membershipTypeId"
                  }
                ],
                "concreteType": "LessonRateConnection",
                "kind": "LinkedField",
                "name": "rates",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LessonRateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LessonRate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v28/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "LessonType",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v18/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v36/*: any*/)
                ],
                "type": "MemberUser",
                "abstractKey": null
              },
              (v13/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "active",
                            "value": true
                          },
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 25
                          },
                          (v15/*: any*/)
                        ],
                        "concreteType": "ClientConnection",
                        "kind": "LinkedField",
                        "name": "clients",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ClientEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v18/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v41/*: any*/),
                                    "type": "Member",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v41/*: any*/),
                                    "type": "Customer",
                                    "abstractKey": null
                                  },
                                  (v42/*: any*/),
                                  (v43/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v43/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientClass",
                    "storageKey": null
                  },
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isClient"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v36/*: any*/),
                      (v13/*: any*/),
                      (v55/*: any*/),
                      (v38/*: any*/),
                      (v39/*: any*/),
                      (v40/*: any*/)
                    ],
                    "type": "Customer",
                    "abstractKey": null
                  },
                  (v42/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v55/*: any*/),
                      (v13/*: any*/),
                      (v37/*: any*/),
                      (v38/*: any*/),
                      (v39/*: any*/),
                      (v40/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberGroup",
                        "kind": "LinkedField",
                        "name": "memberGroups",
                        "plural": true,
                        "selections": (v28/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "Member",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isClientProfile"
              },
              (v42/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "08ae4d5dbccc378f4172b3de1f767c39",
    "id": null,
    "metadata": {},
    "name": "LessonBookingWizardQueryRendererQuery",
    "operationKind": "query",
    "text": "query LessonBookingWizardQueryRendererQuery(\n  $slotId: ID!\n  $membershipTypeId: ID!\n  $players: [ID]\n  $currentDate: Date!\n  $slotType: SlotType\n  $instructorId: ID!\n  $lessonTypeId: ID!\n  $facilityId: ID!\n  $clubSlug: String!\n  $bookingType: BookingType!\n) {\n  currentServerTime\n  club(slug: $clubSlug) {\n    ...BookingWizardUIHeaderFragment\n    id\n  }\n  node(id: $slotId) {\n    __typename\n    id\n    ...AddPlayersStepNode\n    ...useInitializeLessonBookingWizardNode\n    ...LessonWizardStepContainerNode\n    ...BookingWizardUIFooterFragment\n  }\n  lessonRates: node(id: $lessonTypeId) {\n    __typename\n    ...useInitializeLessonBookingWizardLessonType\n    id\n  }\n  session {\n    ...useInitializeLessonBookingWizardSession\n    currentClientProfile {\n      __typename\n      ...AddPlayersStepClientProfile_zYVbD\n      ...AddPlayersPrivateStepClientProfile\n      ...PreviousBookingsStepClientProfile\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment AddPlayersHeaderNode on Node {\n  __isNode: __typename\n  ... on TimeSlot {\n    requirePlayerCounts\n    standardCapacity: capacity(bookingType: STANDARD)\n    usedCapacity\n  }\n}\n\nfragment AddPlayersPrivateStepClientProfile on ClientProfile {\n  __isClientProfile: __typename\n  member {\n    __typename\n    clientClass\n    ... on Member {\n      id\n      firstName\n      lastName\n      profileImage {\n        publicId: renderingKey\n      }\n      memberGroups {\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment AddPlayersPrivateStepNode on Node {\n  __isNode: __typename\n  ...AddPlayersHeaderNode\n  ... on TimeSlot {\n    requirePlayerCounts\n    standardCapacity: capacity(bookingType: STANDARD)\n    usedCapacity\n    agenda {\n      facility {\n        type\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment AddPlayersStepClientProfile_zYVbD on ClientProfile {\n  __isClientProfile: __typename\n  member {\n    __typename\n    club {\n      ...AddPlayers_Clients_zYVbD\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment AddPlayersStepNode on Node {\n  __isNode: __typename\n  ... on QueueSlot {\n    __typename\n  }\n  ... on TimeSlot {\n    requirePlayerCounts\n  }\n}\n\nfragment AddPlayers_Clients_zYVbD on Club {\n  clients(first: 25, active: true, players: $players) {\n    edges {\n      node {\n        __typename\n        membershipType {\n          __typename\n          id\n        }\n        ... on Member {\n          id\n          fullName\n          firstName\n          lastName\n          profileImage {\n            publicId: renderingKey\n          }\n        }\n        ... on Customer {\n          id\n          fullName\n          firstName\n          lastName\n          profileImage {\n            publicId: renderingKey\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  id\n}\n\nfragment BookingCard_Booking on Booking {\n  __isBooking: __typename\n  __typename\n  id\n  requestScheduleBlockingScope\n  ...useShouldPresentBookingAsLockedRequest_booking\n  rounds {\n    edges {\n      node {\n        __typename\n        id\n        player {\n          __typename\n          firstName\n          lastName\n          profileImage {\n            publicId: renderingKey\n          }\n          id\n        }\n      }\n    }\n  }\n  startSlot {\n    __typename\n    ...useHasUnpublishedRequestRestrictions_slot\n    agenda {\n      date\n      facility {\n        club {\n          supportsPublic\n          id\n        }\n        privateBookingPermissionSet {\n          clientCanFulfillRequests\n          id\n        }\n        publicBookingPermissionSet {\n          clientCanFulfillRequests\n          id\n        }\n        type\n        lessonsDisplayName\n        copyOverrides {\n          lesson {\n            singular\n          }\n        }\n        department {\n          type\n          name\n          id\n        }\n        name\n        courses {\n          count\n        }\n        id\n      }\n      id\n    }\n    ... on TimeSlot {\n      time\n      groupLabel\n      holeOffset\n      bookings {\n        edges {\n          node {\n            __typename\n            rounds {\n              edges {\n                node {\n                  __typename\n                  id\n                  player {\n                    __typename\n                    firstName\n                    lastName\n                    profileImage {\n                      publicId: renderingKey\n                    }\n                    id\n                  }\n                }\n              }\n            }\n            id\n          }\n        }\n      }\n      course {\n        name\n        courseBucket {\n          name\n          id\n        }\n        id\n      }\n    }\n    ... on BucketTimeSlot {\n      time\n    }\n    id\n  }\n  ... on StandardBooking {\n    seriesIndex\n    seriesCount\n    fullfillableSlots {\n      id\n    }\n    status\n    slots {\n      edges {\n        node {\n          __typename\n          ... on TimeSlot {\n            time\n          }\n          id\n        }\n      }\n    }\n    request {\n      time\n      id\n    }\n  }\n  ... on LessonBooking {\n    seriesIndex\n    seriesCount\n    durationMins\n    request {\n      time\n      id\n    }\n    instructors {\n      edges {\n        node {\n          id\n          user {\n            fullName\n            id\n          }\n        }\n      }\n    }\n  }\n  ... on DiningBooking {\n    roomName\n  }\n}\n\nfragment BookingWizardUIFooterFragment on Node {\n  __isNode: __typename\n  ...WizardFooter_Node\n}\n\nfragment BookingWizardUIHeaderFragment on Club {\n  ...ClubLogo_Club\n  name\n  logoImage {\n    publicId: renderingKey\n  }\n}\n\nfragment ClubLogo_Club on Club {\n  logoImage {\n    publicId: renderingKey\n  }\n}\n\nfragment GroupSizeControlNode on Node {\n  __isNode: __typename\n  __typename\n  ... on TimeSlot {\n    type\n    standardCapacity: capacity(bookingType: STANDARD)\n    usedCapacity\n  }\n  ... on AvailabilitySlot {\n    id\n    startSlots(slotAvailability: {facilityId: $facilityId, bookingType: LESSON, lessonTypeId: $lessonTypeId}) {\n      edges {\n        node {\n          id\n          capacity(bookingType: LESSON, lessonTypeId: $lessonTypeId)\n          usedCapacity\n        }\n      }\n    }\n  }\n}\n\nfragment LessonBookingDetailsStepNode on Node {\n  __isNode: __typename\n  id\n  ...GroupSizeControlNode\n  ...LessonCourseControlNode\n  ... on AvailabilitySlot {\n    firstStartSlot: startSlots(first: 1, slotAvailability: {facilityId: $facilityId, bookingType: LESSON, lessonTypeId: $lessonTypeId}) {\n      edges {\n        node {\n          id\n          agenda {\n            facility {\n              club {\n                supportsPrivate\n                id\n              }\n              privateLessonsPermissionSet {\n                patronAccess\n                id\n              }\n              publicLessonsPermissionSet {\n                patronAccess\n                id\n              }\n              id\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment LessonCourseControlNode on Node {\n  __isNode: __typename\n  ... on AvailabilitySlot {\n    allLessonStartSlotIds: startSlots(slotAvailability: {facilityId: $facilityId, bookingType: LESSON, lessonTypeId: $lessonTypeId}) {\n      edges {\n        node {\n          id\n          course {\n            id\n          }\n        }\n      }\n    }\n    firstStartSlot: startSlots(first: 1, slotAvailability: {facilityId: $facilityId, bookingType: LESSON, lessonTypeId: $lessonTypeId}) {\n      edges {\n        node {\n          id\n          agenda {\n            facility {\n              type\n              club {\n                supportsPrivate\n                id\n              }\n              privateLessonsPermissionSet {\n                patronSelectVenue\n                patronAccess\n                id\n              }\n              publicLessonsPermissionSet {\n                patronSelectVenue\n                patronAccess\n                id\n              }\n              copyOverrides {\n                course {\n                  singular\n                }\n              }\n              courses {\n                edges {\n                  node {\n                    courseBucket {\n                      id\n                    }\n                    id\n                    name\n                    description\n                    facility {\n                      type\n                      id\n                    }\n                  }\n                }\n              }\n              id\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment LessonWizardStepContainerNode on Node {\n  __isNode: __typename\n  ...LessonBookingDetailsStepNode\n  ...AddPlayersStepNode\n  ...PreviousBookingsStep_TimeSlot\n  ...AddPlayersPrivateStepNode\n}\n\nfragment PreviousBookingsListClient_3GxKZF on Client {\n  __isClient: __typename\n  ... on Member {\n    id\n    repeatableBookings(dateLte: $currentDate, slotType: $slotType) {\n      __typename\n      ... on StandardBooking {\n        id\n        startSlot {\n          __typename\n          type\n          ... on TimeSlot {\n            usedCapacity\n            standardCapacity: capacity(bookingType: STANDARD)\n          }\n          id\n        }\n        rounds {\n          edges {\n            node {\n              __typename\n              id\n              ... on MemberRound {\n                nonPlayingHost\n              }\n              player {\n                __typename\n                fullName\n                id\n              }\n            }\n          }\n        }\n      }\n      ...PreviousBookingsListItem\n      id\n    }\n  }\n  ... on Customer {\n    id\n    repeatableBookings(dateLte: $currentDate, slotType: $slotType) {\n      __typename\n      ... on StandardBooking {\n        id\n        startSlot {\n          __typename\n          type\n          ... on TimeSlot {\n            usedCapacity\n            standardCapacity: capacity(bookingType: STANDARD)\n          }\n          id\n        }\n        rounds {\n          edges {\n            node {\n              __typename\n              id\n              ... on MemberRound {\n                nonPlayingHost\n              }\n              player {\n                __typename\n                fullName\n                id\n              }\n            }\n          }\n        }\n      }\n      ...PreviousBookingsListItem\n      id\n    }\n  }\n}\n\nfragment PreviousBookingsListItem on StandardBooking {\n  id\n  durationMins\n  rounds {\n    edges {\n      node {\n        __typename\n        courseLayout {\n          code\n          name\n          holeCount\n          id\n        }\n        player {\n          __typename\n          id\n          fullName\n          firstName\n          lastName\n          profileImage {\n            publicId: renderingKey\n          }\n        }\n        id\n      }\n    }\n  }\n  startSlot {\n    __typename\n    type\n    agenda {\n      date\n      facility {\n        club {\n          supportsPrivate\n          id\n        }\n        id\n      }\n      id\n    }\n    ... on TimeSlot {\n      time\n    }\n    id\n  }\n}\n\nfragment PreviousBookingsStepClientProfile on ClientProfile {\n  __isClientProfile: __typename\n  member {\n    __typename\n    ...PreviousBookingsListClient_3GxKZF\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment PreviousBookingsStep_TimeSlot on TimeSlot {\n  capacity(bookingType: $bookingType)\n  usedCapacity\n}\n\nfragment SquareCardFragment on SquareCardOnFile {\n  __typename\n  id\n  cardBrand\n  enabled\n  expMonth\n  expYear\n  lastFour\n  default\n}\n\nfragment WizardFooter_Node on Node {\n  __isNode: __typename\n  __typename\n  ... on TimeSlot {\n    id\n    lockedUntil\n    agenda {\n      id\n    }\n  }\n}\n\nfragment useBookingPaymentCards_session_1gpj4o on Session {\n  user {\n    __typename\n    ... on MemberUser {\n      squareCards(enabled: true, validOnDate: $currentDate) {\n        edges {\n          node {\n            id\n            enabled\n            default\n            expMonth\n            expYear\n            ...SquareCardFragment\n          }\n        }\n      }\n    }\n    id\n  }\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      ... on Customer {\n        squareCards(enabled: true, validOnDate: $currentDate) {\n          edges {\n            node {\n              id\n              enabled\n              default\n              expMonth\n              expYear\n              ...SquareCardFragment\n            }\n          }\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useGetRequiredWizardSteps on ClientProfile {\n  __isClientProfile: __typename\n  member {\n    __typename\n    ... on Member {\n      repeatableBookings(dateLte: $currentDate, slotType: $slotType) {\n        __typename\n        id\n        rounds {\n          edges {\n            node {\n              __typename\n              player {\n                __typename\n                id\n              }\n              id\n            }\n          }\n        }\n        ...BookingCard_Booking\n      }\n    }\n    ... on Customer {\n      id\n      repeatableBookings(dateLte: $currentDate, slotType: $slotType) {\n        __typename\n        id\n        rounds {\n          edges {\n            node {\n              __typename\n              player {\n                __typename\n                id\n              }\n              id\n            }\n          }\n        }\n        ...BookingCard_Booking\n      }\n    }\n    club {\n      clients(first: 25, active: true, players: $players) {\n        edges {\n          node {\n            __typename\n            ... on Member {\n              id\n            }\n            ... on Customer {\n              id\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n        }\n      }\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useHasUnpublishedRequestRestrictions_slot on Slot {\n  __isSlot: __typename\n  __typename\n  ... on QueueSlot {\n    agenda {\n      configuredRequestRestrictions: requestWindowBookingRules(type: [REQUEST]) {\n        edges {\n          liftAt\n          requestCloses\n        }\n      }\n      id\n    }\n  }\n  ... on TimeSlot {\n    configuredRequestRestrictions: requestWindowBookingRules(type: [REQUEST]) {\n      edges {\n        liftAt\n        requestCloses\n      }\n    }\n  }\n}\n\nfragment useInitializeLessonBookingWizardLessonType on Node {\n  __isNode: __typename\n  id\n  ... on LessonType {\n    defaultDurationMins\n    durations(instructorId: $instructorId)\n    rates(instructorIds: [$instructorId], membershipTypeId: $membershipTypeId) {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment useInitializeLessonBookingWizardNode on Node {\n  __isNode: __typename\n  ... on AvailabilitySlot {\n    id\n    firstStartSlot: startSlots(first: 1, slotAvailability: {facilityId: $facilityId, bookingType: LESSON, lessonTypeId: $lessonTypeId}) {\n      edges {\n        node {\n          id\n          capacity(bookingType: LESSON, lessonTypeId: $lessonTypeId)\n          usedCapacity\n          course {\n            id\n          }\n          agenda {\n            date\n            queueSlot {\n              id\n            }\n            facility {\n              club {\n                supportsPrivate\n                id\n              }\n              privateLessonsPermissionSet {\n                patronSelectVenue\n                patronAccess\n                id\n              }\n              publicLessonsPermissionSet {\n                patronSelectVenue\n                patronAccess\n                id\n                requirePaymentCardOnFile\n                prePaymentRequirement\n              }\n              id\n              name\n              minMaxGroupSize(bookingType: LESSON) {\n                min\n                max\n              }\n            }\n            id\n          }\n        }\n      }\n    }\n    allStartSlodIds: startSlots(slotAvailability: {facilityId: $facilityId, bookingType: LESSON, lessonTypeId: $lessonTypeId}) {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment useInitializeLessonBookingWizardSession on Session {\n  ...useBookingPaymentCards_session_1gpj4o\n  currentClientProfile {\n    __typename\n    ...useGetRequiredWizardSteps\n    member {\n      __typename\n      membershipType {\n        __typename\n        id\n      }\n      ... on Member {\n        id\n        fullName\n        firstName\n        lastName\n        profileImage {\n          publicId: renderingKey\n        }\n      }\n      ... on Customer {\n        id\n        firstName\n        lastName\n        profileImage {\n          publicId: renderingKey\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useShouldPresentBookingAsLockedRequest_booking on Booking {\n  __isBooking: __typename\n  startSlot {\n    __typename\n    agenda {\n      configuredRequestRestrictions: requestWindowBookingRules(type: [REQUEST]) {\n        edges {\n          liftAt\n          requestCloses\n          node {\n            id\n            __typename\n            ... on RequestRule {\n              requestConfig {\n                id\n              }\n            }\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n  ... on StandardBooking {\n    request {\n      bookingRule {\n        id\n        __typename\n        ... on RequestRule {\n          requestConfig {\n            id\n          }\n        }\n      }\n      id\n    }\n  }\n  ... on LessonBooking {\n    request {\n      bookingRule {\n        id\n        __typename\n        ... on RequestRule {\n          requestConfig {\n            id\n          }\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5c7a9ed96717cbdf5794f00aa5f1388e";

export default node;
